import React from 'react';

import {Helmet} from 'views/module';

import CaseListScene from 'views/scenes/case/list/CaseList';

const CaseList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Cases</title>
      </Helmet>
      <CaseListScene />
    </>
  );
};

export default CaseList;
